function initProductBundles() {
  const flavors = document.querySelectorAll(".product-bundle-flavors-item");
  const discountCards = document.querySelectorAll(
    ".product-bundle-discounts-card"
  );

  if (!flavors.length || !discountCards.length) {
    return;
  }

  const submitButton = document.querySelector(".product-bundle-submit-button");
  const removeButtons = document.querySelectorAll(".status-btn--remove");

  let selectedOptions = [];
  let selectedVariants = [];
  let activeDiscountCard = document.querySelector(
    ".product-bundle-discounts-card.selected"
  );

  // ✅ FIX: make click async + await the cart add + free gift sync
  submitButton.addEventListener("click", async () => {
    submitButton.disabled = true;
    submitButton.classList.add("loading");

    try {
      await addBuildABoxItems(selectedVariants);
    } catch (err) {
      console.error(err);
      submitButton.disabled = false;
      submitButton.classList.remove("loading");
    }
  });

  removeButtons.forEach((button) =>
    button.addEventListener("click", (e) => {
      e.stopPropagation();

      const parentFlavor = button.closest(".product-bundle-flavors-item");

      removeFlavor(parentFlavor);
      updateFallbackImages(activeDiscountCard);
      updateFlavorImages();
      checkLimit(activeDiscountCard);
      updateBundlePrice();
      generateSelectedVariantsArr();
    })
  );

  flavors.forEach((flavor) =>
    flavor.addEventListener("click", () => {
      if (flavor.classList.contains("disabled")) {
        return;
      }

      addFlavor(flavor);
      updateFallbackImages(activeDiscountCard);
      updateFlavorImages();
      checkLimit(activeDiscountCard);
      updateBundlePrice();
      generateSelectedVariantsArr();
    })
  );

  discountCards.forEach((card) =>
    card.addEventListener("click", () => {
      changeActiveDiscountCard(card);

      updateFallbackImages(card);
      checkLimit(activeDiscountCard);
      updateFlavorImages();
      updateBundlePrice();
      generateSelectedVariantsArr();
    })
  );

  // ✅ FIXED FUNCTION
  async function addBuildABoxItems(items) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) throw new Error("Error adding to cart");

      // ✅ IMPORTANT: wait for the free gift logic to finish BEFORE checkout redirect
      if (window.FreeGift && typeof window.FreeGift.sync === "function") {
        await window.FreeGift.sync();
      }

      if (activeDiscountCard.dataset.discountCode != "") {
        window.location.href = `/checkout?discount=${activeDiscountCard.dataset.discountCode}`;
      } else {
        window.location.href = "/checkout";
      }
    } catch (error) {
      console.error(error);

      // If error occurs, allow button again
      submitButton.disabled = false;
      submitButton.classList.remove("loading");
    }
  }

  function removeFlavor(flavor) {
    const flavorProductId = +flavor.dataset.productId;
    const flavorIndex = selectedOptions.findIndex(
      (obj) => obj.id === flavorProductId
    );

    if (flavorIndex < 0) {
      return;
    }

    if (selectedOptions[flavorIndex].quantity > 1) {
      selectedOptions[flavorIndex].quantity -= 1;
    } else {
      selectedOptions.splice(flavorIndex, 1);
    }

    changeFlavorState(flavor, flavorProductId);
  }

  function generateSelectedVariantsArr() {
    if (!selectedOptions.length) {
      return;
    }

    selectedVariants = [];

    selectedOptions.forEach((option, index) => {
      const selectedFlavor = document.querySelector(
        `.product-bundle-flavors-item[data-product-id="${option.id}"]`
      );

      selectedVariants.push({
        id: selectedFlavor.dataset.productVariantId,
        quantity: option.quantity,
        properties: {
          _bundle_id: "Build a Box",
          _discount_percentage: +activeDiscountCard.dataset.discountValue,
        },
      });
    });
  }

  function updateBundlePrice() {
    const originalPriceEl = document.querySelector(
      ".product-bundle-actions-price .original-price"
    );
    const discountedPriceEl = document.querySelector(
      ".product-bundle-actions-price .new-price"
    );
    const discountEl = document.querySelector(
      ".product-bundle-actions-price .discount"
    );

    const discountPercent = +activeDiscountCard.dataset.discountValue;

    const currencyFormatter = new Intl.NumberFormat(Shopify.locale, {
      style: "currency",
      currency: Shopify.currency.active,
      currencyDisplay: "symbol",
    });

    updateGeneralPriceBox();

    function updateGeneralPriceBox() {
      let total = 0;

      selectedOptions.forEach((option) => {
        const selectedFlavor = document.querySelector(
          `.product-bundle-flavors-item[data-product-id="${option.id}"]`
        );
        const selectedFlavorQuantity = +option.quantity;
        const price =
          parseFloat(+selectedFlavor.dataset.productPrice) *
          selectedFlavorQuantity;
        if (!isNaN(price)) total += price;
      });

      const discountedTotal = total - (total * discountPercent) / 100;

      originalPriceEl.textContent = currencyFormatter.format(total);
      discountedPriceEl.textContent = currencyFormatter.format(discountedTotal);

      if (discountedTotal > 0) {
        discountEl.hidden = false;
        discountEl.querySelector("span").innerHTML = discountPercent;
      } else {
        discountEl.hidden = true;
      }
    }
  }

  function checkLimit(card) {
    const cardMaxQuantity = +card.dataset.quantity;
    let totalQuantity = selectedOptions.reduce(
      (sum, item) => sum + item.quantity,
      0
    );

    if (totalQuantity > cardMaxQuantity) {
      while (totalQuantity > cardMaxQuantity) {
        const lastOptionIndex = selectedOptions.length - 1;
        const lastOptionQuantity = selectedOptions[lastOptionIndex].quantity;

        if (lastOptionQuantity > 1) {
          selectedOptions[lastOptionIndex].quantity -= 1;
        } else {
          const removedOption = selectedOptions.pop();
          const removedFlavorID = removedOption.id;
          const removedFlavor = document.querySelector(
            `.product-bundle-flavors-item[data-product-id="${removedFlavorID}"]`
          );

          if (removedFlavor) {
            removedFlavor.classList.remove("selected");
          }
        }

        totalQuantity = selectedOptions.reduce(
          (sum, item) => sum + item.quantity,
          0
        );
      }

      flavors.forEach((flavor) => {
        const flavorProductId = +flavor.dataset.productId;
        changeFlavorState(flavor, flavorProductId);
      });
    }

    if (totalQuantity == cardMaxQuantity) {
      flavors.forEach((flavor) => {
        if (!flavor.classList.contains("selected")) {
          flavor.classList.add("disabled");
        }
      });
      submitButton.classList.remove("disabled");
      submitButton.disabled = false;
    } else if (totalQuantity < cardMaxQuantity) {
      flavors.forEach((flavor) => flavor.classList.remove("disabled"));
      submitButton.classList.add("disabled");
      submitButton.disabled = true;
    }
  }

  function addFlavor(flavor) {
    const cardMaxQuantity = +activeDiscountCard.dataset.quantity;
    let totalQuantity = selectedOptions.reduce(
      (sum, item) => sum + item.quantity,
      0
    );

    if (totalQuantity === cardMaxQuantity) {
      return;
    }

    const flavorProductId = +flavor.dataset.productId;
    const found = selectedOptions.findIndex(
      (obj) => obj.id === flavorProductId
    );

    if (!selectedOptions.length || found < 0) {
      selectedOptions.push({
        id: flavorProductId,
        quantity: 1,
      });
    } else {
      selectedOptions[found].quantity += 1;
    }

    changeFlavorState(flavor, flavorProductId);
  }

  function changeFlavorState(flavor, flavorProductId) {
    const found = selectedOptions.findIndex(
      (obj) => obj.id === flavorProductId
    );

    if (found >= 0) {
      flavor.querySelector(".status-count").textContent =
        selectedOptions[found].quantity;

      if (!flavor.classList.contains("selected")) {
        flavor.classList.add("selected");
      }
    } else {
      flavor.querySelector(".status-count").textContent = 0;
      flavor.classList.remove("selected");
    }
  }

  function changeActiveDiscountCard(clickedCard) {
    discountCards.forEach((card) => card.classList.remove("selected"));
    clickedCard.classList.add("selected");
    activeDiscountCard = clickedCard;
    document.querySelector(".product-bundle-media-pack-wrapper").dataset.grid =
      clickedCard.dataset.quantity;
  }

  function updateFlavorImages() {
    const flavorImage = document.querySelectorAll(
      ".product-bundle-media-image--flavor"
    );
    const flavorDuplicateImages = document.querySelectorAll(".duplicate-image");

    let styleIndex = 0;

    flavorDuplicateImages.forEach((image) => image.remove());
    flavorImage.forEach((image) => (image.hidden = true));

    selectedOptions.forEach((option) => {
      const optionImage = document.querySelector(
        `.product-bundle-media-image--flavor[data-product-id="${option.id}"]`
      );

      for (let index = 1; index <= option.quantity; index++) {
        const cloneImage = optionImage.cloneNode(true);

        cloneImage.style.order = styleIndex;
        cloneImage.hidden = false;
        cloneImage.classList.add("duplicate-image");
        document
          .querySelector(".product-bundle-media-pack-wrapper")
          .appendChild(cloneImage);

        styleIndex += 1;
      }
    });
  }

  function updateFallbackImages(activeCard) {
    const productQuantity = +activeCard.dataset.quantity;
    const fallbackImages = document.querySelectorAll(
      ".product-bundle-media-image--fallback"
    );
    const totalQuantity = selectedOptions.reduce(
      (sum, item) => sum + item.quantity,
      0
    );

    fallbackImages.forEach((image) => (image.hidden = true));

    const numberOfActiveFallbackImages = productQuantity - totalQuantity;
    fallbackImages.forEach((image, index) => {
      if (index < numberOfActiveFallbackImages) {
        image.hidden = false;
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initProductBundles();
});